<template lang="pug">
.content-wrap
	topbar
	.content-top
		.con
			//- highlight
			rtt
			googleSearch
			.cat-tab.nbswi(ref="categories")
				.swiper.glcat-swiper.nbswi-swiper
					.swiper-wrapper
						//- .swiper-slide
							.cat(@click="redirectPath('/')")
								img(src='/new/img/tab/c-hot.png')
								| hot
						.swiper-slide
							.cat.aaa
								img(src='/new/img/tab/c-slot.png')
								| slots
						template(v-if="isLoggedIn")
							.swiper-slide
								router-link.cat(to="/launchWbet" target="_blank")
									img(src='/new/img/tab/c-sport.png')
									| sports
						template(v-else)
							.swiper-slide
								a.cat(@click="$router.push('/login').catch(err => {})")
									img(src='/new/img/tab/c-sport.png')
									| sports
						.swiper-slide
							.cat(@click="redirectPath('/casino')")
								img(src='/new/img/tab/c-casino.png')
								| live
						.swiper-slide
							.cat(@click="redirectPath('/table')")
								img(src='/new/img/tab/c-poker.png')
								| poker
						//- .swiper-slide
							.cat(@click="redirectPath('/bingo')")
								img(src='/new/img/tab/c-bingo.png')
								| bingo
						.swiper-slide
							.cat(@click="redirectPath('/fishing')")
								img(src='/new/img/tab/c-fish.png')
								| fishing
						.swiper-slide
							.cat(@click="redirectPath('/minigame')")
								img(src='/new/img/tab/c-arcade.png')
								| minigame
						//- .swiper-slide
							.cat(@click="redirectPath('/crash')")
								img(src='/new/img/tab/c-crash.png')
								| crash
						//- .swiper-slide
							.cat(@click="redirectPath('/lottery')")
								img(src='/new/img/tab/c-lottery.png')
								| lottery
				.swiper-button-prev.glcat-swiper-prev
				.swiper-button-next.glcat-swiper-next
			div(v-show="showLobby")
				.dropdown-wrapper
					a(v-for="list in visibleItems" href="javascript:void(0)" @click="selectOption(list.option, list.code, list.fallb)")
						.pvd-img
							img(:src="`/new/img/products/${list.img}.png`")
				.load.mt-3(v-if="visibleItems.length < listToDisplay.length" @click="loadMore")
					| Load more 
					span.loaded {{ visibleItems.length }} /
					| {{ listToDisplay.length }}
					//- a(href='javascript:void(0)' @click="selectOption(30, 'KISSH5', 'kissh5')")
					//- 	.pvd-img
					//- 		img(src='/new/img/products/kissh5.png')
					//- //- a(href='javascript:void(0)' @click="selectOption(31, 'MEGA888', 'mega888')")
					//- 	.pvd-img
					//- 		img(src='/new/img/products/mega888.png')
					//- a(href='javascript:void(0)' @click="selectOption(0)")
					//- 	.pvd-img
					//- 		img(src='/new/img/products/epicwin.png')
					//- a.hot-game(href='javascript:void(0)' @click="selectOption(1)")
					//- 	.pvd-img
					//- 		img(src='/new/img/products/megah5.png')
					//- a.hot-game(href='javascript:void(0)' @click="selectOption(2)")
					//- 	.pvd-img
					//- 		img(src='/new/img/products/pragmatic.png')
					//- a.hot-game(href='javascript:void(0)' @click="selectOption(3)")
					//- 	.pvd-img
					//- 		img(src='/new/img/products/jili.png')
					//- a(href='javascript:void(0)' @click="selectOption(4)")
					//- 	.pvd-img
					//- 		img(src='/new/img/products/live22.png')
					//- a(href='javascript:void(0)' @click="selectOption(5)")
					//- 	.pvd-img
					//- 		img(src='/new/img/products/spade.png')
					//- a(href='javascript:void(0)' @click="selectOption(6)")
					//- 	.pvd-img
					//- 		img(src='/new/img/products/joker.png')
					//- a(href='javascript:void(0)' @click="selectOption(7)")
					//- 	.pvd-img
					//- 		img(src='/new/img/products/habanero.png')
					//- a(href='javascript:void(0)' @click="selectOption(8)")
					//- 	.pvd-img
					//- 		img(src='/new/img/products/cq9.png')
					//- a(href='javascript:void(0)' @click="selectOption(9)")
					//- 	.pvd-img
					//- 		img(src='/new/img/products/fachai.png')
					//- a(href='javascript:void(0)' @click="selectOption(10)")
					//- 	.pvd-img
					//- 		img(src='/new/img/products/jdb.png')
					//- a(href='javascript:void(0)' @click="selectOption(11)")
					//- 	.pvd-img
					//- 		img(src='/new/img/products/jdb-gtf.png')
					//- a(href='javascript:void(0)' @click="selectOption(12)")
					//- 	.pvd-img
					//- 		img(src='/new/img/products/microgaming.png')
					//- a(href='javascript:void(0)' @click="selectOption(24)")
					//- 	.pvd-img
					//- 		img(src='/new/img/products/hacksaw.png')
					//- a(href='javascript:void(0)' @click="selectOption(21)")
					//- 	.pvd-img
					//- 		img(src='/new/img/products/nolimit.png')
					//- a(href='javascript:void(0)' @click="selectOption(22)")
					//- 	.pvd-img
					//- 		img(src='/new/img/products/bng.png')
					//- //- a(href='javascript:void(0)' @click="selectOption(13)")
					//- 	.pvd-img
					//- 		img(src='/new/img/products/spinix.png')
					//- a(href='javascript:void(0)' @click="selectOption(13)")
					//- 	.pvd-img
					//- 		img(src='/new/img/products/bgaming.png')
					//- a(href='javascript:void(0)' @click="selectOption(14)")
					//- 	.pvd-img
					//- 		img(src='/new/img/products/yesbingo.png')
					//- a(href='javascript:void(0)' @click="selectOption(15)")
					//- 	.pvd-img
					//- 		img(src='/new/img/products/relax.png')
					//- a(href='javascript:void(0)' @click="selectOption(16)")
					//- 	.pvd-img
					//- 		img(src='/new/img/products/evoplay.png')
					//- a(href='javascript:void(0)' @click="selectOption(17)")
					//- 	.pvd-img
					//- 		img(src='/new/img/products/png.png')
					//- a(href='javascript:void(0)' @click="selectOption(18)")
					//- 	.pvd-img
					//- 		img(src='/new/img/products/netent.png')
					//- a(href='javascript:void(0)' @click="selectOption(19)")
					//- 	.pvd-img
					//- 		img(src='/new/img/products/redtiger.png')
					//- a(href='javascript:void(0)' @click="selectOption(20)")
					//- 	.pvd-img
					//- 		img(src='/new/img/products/btg.png')
					//- a(href='javascript:void(0)' @click="selectOption(23)")
					//- 	.pvd-img
					//- 		img(src='/new/img/products/advant-play.png')
					//- a(href='javascript:void(0)' @click="selectOption(25, 'GPK7MJ', '7mojo')")
					//- 	.pvd-img
					//- 		img(src='/new/img/products/7mojo.png')
					//- a(href='javascript:void(0)' @click="selectOption(26, 'GPKBM', 'booming')")
					//- 	.pvd-img
					//- 		img(src='/new/img/products/booming.png')
					//- a(href='javascript:void(0)' @click="selectOption(27, 'GPKSPINO', 'spinomenal')")
					//- 	.pvd-img
					//- 		img(src='/new/img/products/spinomenal.png')
					//- a(href='javascript:void(0)' @click="selectOption(28, 'SSG', 'smartsoft')")
					//- 	.pvd-img
					//- 		img(src='/new/img/products/smartsoft.png')
					//- a(href='javascript:void(0)' @click="selectOption(29, 'QM', 'kingmidas')")
						.pvd-img
							img(src='/new/img/products/kingmaker.png')
			div(v-show="!showLobby")
				.searchbar
					.fav.pointer(v-if="isLoggedIn" @click="toggleFav")
						i.fa-heart(:class="{'fa-solid fav-red': showFav, 'fa-regular': !showFav}")
					.fav.pointer(v-if="!isLoggedIn" @click="$router.push('/login').catch(err => {})")
						i.fa-regular.fa-heart
					input.form-control(type='text' v-model="searchinput" placeholder='Search')
					.s-icon
						i.fa-solid.fa-magnifying-glass
				.glmenu.nbswi.mt-2
					.swiper.glpro-swiper.nbswi-swiper
						.swiper-wrapper
							.swiper-slide(@click="changeProvider(0)")
								.g-pro.pro(:class="{'aaa' : providerSelected === 0}")
									img(:src="getImg('epic2')")
							.swiper-slide(@click="changeProvider(1)")
								.g-pro.pro(:class="{'aaa' : providerSelected === 1}")
									img(:src="getImg('megah5')")
							.swiper-slide(@click="changeProvider(2)")
								.g-pro.pro(:class="{'aaa c-filter' : providerSelected === 2, 'c-filter1': providerSelected !== 2}")
									img(:src="getImg('pragmatic')")
							.swiper-slide(@click="changeProvider(3)")
								.g-pro.pro(:class="{'aaa' : providerSelected === 3}")
									img(:src="getImg('jili')")
							.swiper-slide(@click="changeProvider(4)")
								.g-pro.pro(:class="{'aaa' : providerSelected === 4}")
									img(:src="getImg('live22')")
							.swiper-slide(@click="changeProvider(5)")
								.g-pro.pro(:class="{'aaa' : providerSelected === 5}")
									img(:src="getImg('spdg')")
							.swiper-slide(@click="changeProvider(6)")
								.g-pro.pro(:class="{'aaa' : providerSelected === 6}")
									img(:src="getImg('joker')")
							.swiper-slide(@click="changeProvider(7)")
								.g-pro.pro(:class="{'aaa' : providerSelected === 7}")
									img(:src="getImg('habanero')")
							.swiper-slide(@click="changeProvider(8)")
								.g-pro.pro(:class="{'aaa' : providerSelected === 8}")
									img(:src="getImg('cq9')")
							.swiper-slide(@click="changeProvider(9)")
								.g-pro.pro(:class="{'aaa' : providerSelected === 9}")
									img(:src="getImg('fc')")
							.swiper-slide(@click="changeProvider(10)")
								.g-pro.pro(:class="{'aaa' : providerSelected === 10}")
									img(:src="getImg('jdb')")
							.swiper-slide(@click="changeProvider(11)")
								.g-pro.pro(:class="{'aaa c-filter' : providerSelected === 11, 'c-filter1': providerSelected !== 11}")
									img(:src="getImg('jdbxgtf')")
							.swiper-slide(@click="changeProvider(12)")
								.g-pro.pro(:class="{'aaa' : providerSelected === 12}")
									img(:src="getImg('microgaming')")
							.swiper-slide(@click="changeProvider(13)")
								.g-pro.pro(:class="{'aaa' : providerSelected === 13}")
									img(:src="getImg('bgaming')")
							.swiper-slide(@click="changeProvider(14)")
								.g-pro.pro(:class="{'aaa' : providerSelected === 14}")
									img(:src="getImg('yesbingo')")
							.swiper-slide(@click="changeProvider(15)")
								.g-pro.pro(:class="{'aaa c-filtera' : providerSelected === 15, 'c-filter2': providerSelected !== 15}")
									img(:src="getImg('relax-gaming')")
							.swiper-slide(@click="changeProvider(16)")
								.g-pro.pro(:class="{'aaa c-filtera' : providerSelected === 16, 'c-filter2': providerSelected !== 16}")
									img(:src="getImg('evoplay')")
							.swiper-slide(@click="changeProvider(17)")
								.g-pro.pro(:class="{'aaa' : providerSelected === 17}")
									img(:src="getImg('playngo')")
							.swiper-slide(@click="changeProvider(18)")
								.g-pro.pro(:class="{'aaa' : providerSelected === 18}")
									img(:src="getImg('netent')")
							.swiper-slide(@click="changeProvider(19)")
								.g-pro.pro(:class="{'aaa' : providerSelected === 19}")
									img(:src="getImg('evort')")
							.swiper-slide(@click="changeProvider(20)")
								.g-pro.pro(:class="{'aaa' : providerSelected === 20}")
									img(:src="getImg('big-time-gaming')")
							.swiper-slide(@click="changeProvider(21)")
								.g-pro.pro(:class="{'aaa c-filtera' : providerSelected === 21, 'c-filter2': providerSelected !== 21}")
									img(:src="getImg('nlc')")
							.swiper-slide(@click="changeProvider(22)")
								.g-pro.pro(:class="{'aaa' : providerSelected === 22}")
									img(:src="getImg('bng')")
							.swiper-slide(@click="changeProvider(23)")
								.g-pro.pro(:class="{'aaa' : providerSelected === 23}")
									img(:src="getImg('advantplay')")
							.swiper-slide(@click="changeProvider(24)")
								.g-pro.pro(:class="{'aaa c-filtera' : providerSelected === 24, 'c-filter2': providerSelected !== 24}")
									img(:src="getImg('hacksaw')")
							.swiper-slide(@click="changeProvider(25, 'GPK7MJ', '7mojo')")
								.g-pro.pro(:class="{'aaa' : providerSelected === 25}")
									img(:src="getImg('7mojo')")
							.swiper-slide(@click="changeProvider(26, 'GPKBM', 'booming')")
								.g-pro.pro(:class="{'aaa' : providerSelected === 26}")
									img(:src="getImg('booming')")
							.swiper-slide(@click="changeProvider(27, 'GPKSPINO', 'spinomenal')")
								.g-pro.pro(:class="{'aaa' : providerSelected === 27}")
									img(:src="getImg('spinomenal')")
							.swiper-slide(@click="changeProvider(28, 'SSG', 'smartsoft')")
								.g-pro.pro(:class="{'aaa c-filtera' : providerSelected === 28, 'c-filter2': providerSelected !== 28}")
									img(:src="getImg('smartsoft')")
							.swiper-slide(@click="changeProvider(29, 'QM', 'kingmidas')")
								.g-pro.pro(:class="{'aaa' : providerSelected === 29}")
									img(:src="getImg('kingmidas')")
							.swiper-slide(@click="changeProvider(30, 'KISSH5', 'kissh5')")
								.g-pro.pro(:class="{'aaa' : providerSelected === 30}")
									img(:src="getImg('kissh5')")
							//- .swiper-slide(@click="changeProvider(31, 'MEGA888', 'mega888')")
								.g-pro.pro(:class="{'aaa' : providerSelected === 31}")
									img(:src="getImg('mega888')")
							//- .swiper-slide(v-for="(provider, index) in providerList" @click="changeProvider(provider.provider_code)")
								.g-pro.pro(:class="{'aaa' : providerSelected === provider.provider_code, 'c-filtera': (providerSelected === provider.provider_code) && customImg.includes(provider.provider_code) , 'c-filter2': (providerSelected !== provider.provider_code) && customImg.includes(provider.provider_code), 'c-filter': (providerSelected === provider.provider_code) && customImg2.includes(provider.provider_code), 'c-filter1': (providerSelected !== provider.provider_code) && customImg2.includes(provider.provider_code)}")
									img(:src="getImg(provider.provider_code)")
					.swiper-button-prev.glpro-swiper-prev
					.swiper-button-next.glpro-swiper-next
				favList(v-if="showFav" :searchinput="searchinput")
				epic2(v-if="providerSelected === 0 && !showFav" :searchinput="searchinput")
				megaH5(v-if="providerSelected === 1 && !showFav" :searchinput="searchinput")
				pragmatic(v-if="providerSelected === 2 && !showFav" :searchinput="searchinput")
				jili(v-if="providerSelected === 3 && !showFav" :searchinput="searchinput")
				live22(v-if="providerSelected === 4 && !showFav" :searchinput="searchinput")
				sgGame(v-if="providerSelected === 5 && !showFav" :searchinput="searchinput")
				joker(v-if="providerSelected === 6 && !showFav" :searchinput="searchinput")
				hbGame(v-if="providerSelected === 7 && !showFav" :searchinput="searchinput")
				cq9(v-if="providerSelected === 8 && !showFav" :searchinput="searchinput")
				fc(v-if="providerSelected === 9 && !showFav" :searchinput="searchinput")
				jdb(v-if="providerSelected === 10 && !showFav" :searchinput="searchinput")
				jdbGtf(v-if="providerSelected === 11 && !showFav" :searchinput="searchinput")
				microgaming(v-if="providerSelected === 12 && !showFav" :searchinput="searchinput")
				//- spinix(v-if="providerSelected === 13" :searchinput="searchinput")
				bgaming(v-if="providerSelected === 13 && !showFav" :searchinput="searchinput")
				yesbingo(v-if="providerSelected === 14 && !showFav" :searchinput="searchinput")
				//- hacksawgaming(v-if="providerSelected === 16")
				relaxgaming(v-if="providerSelected === 15 && !showFav" :searchinput="searchinput")
				evoplay(v-if="providerSelected === 16 && !showFav" :searchinput="searchinput")
				playngo(v-if="providerSelected === 17 && !showFav" :searchinput="searchinput")
				netent(v-if="providerSelected === 18 && !showFav" :searchinput="searchinput")
				evort(v-if="providerSelected === 19 && !showFav" :searchinput="searchinput")
				btg(v-if="providerSelected === 20 && !showFav" :searchinput="searchinput")
				nlc(v-if="providerSelected === 21 && !showFav" :searchinput="searchinput")
				bng(v-if="providerSelected === 22 && !showFav" :searchinput="searchinput")
				advantplay(v-if="providerSelected === 23 && !showFav" :searchinput="searchinput")
				hacksawdirect(v-if="providerSelected === 24 && !showFav" :searchinput="searchinput")
				oneApi(v-if="providerSelected > 24 && standaloneProv == false && !showFav" :searchinput="searchinput" :pCode="providerCode" :gameType="'SLOT'" :imgName="imgName" :key="providerCode")
				kissh5(v-if="providerSelected === 30 && !showFav" :searchinput="searchinput")
				//- mega888(v-if="providerSelected === 31 && !showFav" :searchinput="searchinput")
				//- gameList(v-if="!showFav && pageLoading==false" :searchinput="searchinput" :gameType="'slots'" :pCode="providerSelected" :key="providerSelected")
			//- template(v-else)
				.text-center.text-white.my-4.w-100
					i.fa-regular.fa-newspaper.display-6.text-black
					.text-black No data
			eventHighlight.mt-3
			casinoSection.mt-3
			.faq.mt-3
				.title-wrap
					span.title-text HOT MATCH
			wbetWidget
			testimonial.mt-3
			videoList.mt-3
			footerInfo(:target="'/slot'")
</template>
<script>
import { EventBus } from '@/store/event';
import config from "@/config";
import topbar from '@/views/default/_topBar.vue'
import highlight from '@/component/_highlight.vue'
import eventHighlight from '@/component/_eventHighlight.vue'
import casinoSection from '@/component/_casinoSection.vue'
import wbetWidget from '@/component/_wbetWidget.vue'
import testimonial from '@/component/_reviewSection.vue'
import videoList from '@/component/_videoList.vue'
import rtt from '@/component/_realTimeTrans.vue'
import favList from '@/component/slot/_favList.vue'
import footerInfo from '@/views/default/_footerArticle.vue'
import imgList from '@/providerImg'
// import gameList from '@/component/_gameList.vue'
import social from '@/component/_social.vue'
import googleSearch from '@/component/_googleSearch.vue'
import epic2 from '@/component/slot/_epic2.vue'
import megaH5 from '@/component/slot/_megah5.vue'
import pragmatic from '@/component/slot/_pragmatic.vue'
import jili from '@/component/slot/_jili.vue'
import live22 from '@/component/slot/_live22.vue'
import sgGame from '@/component/slot/_spadegaming.vue'
import joker from '@/component/slot/_joker.vue'
import hbGame from '@/component/slot/_habanero.vue'
import cq9 from '@/component/slot/_cq9.vue'
import fc from '@/component/slot/oneapi/_fc.vue'
import jdb from '@/component/slot/oneapi/_jdb.vue'
import jdbGtf from '@/component/slot/oneapi/_jdbGtf.vue'
import microgaming from '@/component/slot/oneapi/_microgaming.vue'
import bgaming from '@/component/slot/oneapi/_bgaming.vue'
import yesbingo from '@/component/slot/oneapi/_yesbingo.vue'
import relaxgaming from '@/component/slot/oneapi/_relaxgaming.vue'
import evoplay from '@/component/slot/oneapi/_evoplay.vue'
import playngo from '@/component/slot/oneapi/_playngo.vue'
import netent from '@/component/slot/oneapi/_netent.vue'
import evort from '@/component/slot/oneapi/_evort.vue'
import btg from '@/component/slot/oneapi/_btg.vue'
import nlc from '@/component/slot/oneapi/_nlc.vue'
import bng from '@/component/slot/oneapi/_bng.vue'
import advantplay from '@/component/slot/oneapi/_advantplay.vue'
import hacksawdirect from '@/component/slot/oneapi/_hacksawdirect.vue'
import oneApi from '@/component/_oneApi.vue'
import kissh5 from '@/component/slot/_kissh5.vue'
import mega888 from '@/component/slot/_mega888.vue'
export default {
	components:{
		topbar,
    highlight,
		eventHighlight,
		casinoSection,
		wbetWidget,
		testimonial,
		videoList,
    rtt,
    footerInfo,
		favList,
		imgList,
		// gameList,
		social,
		googleSearch,
		epic2,
		megaH5,
		pragmatic,
		jili,
		live22,
		sgGame,
		joker,
		hbGame,
		cq9,
		fc,
		jdb,
		jdbGtf,
		microgaming,
		bgaming,
		yesbingo,
		relaxgaming,
		evoplay,
		playngo,
		netent,
		evort,
		btg,
		nlc,
		bng,
		advantplay,
		hacksawdirect,
		oneApi,
		kissh5,
		mega888
	},
	data(){
		return{
			feedback: {
				success: true,
				status: ""
			},
			loading:false,
			showMobile: false,
			providerSelected: 0,
			imgUrl: config.imageUrl,
			showSearch: false,
			providerList:[],
			searchinput:"",
			showFav: false,
      currentPath: "",
			providerImg: imgList.provider,
			pageLoading:true,
			customImg:['EVONE-AIO', 'EVONLC-AIO', 'EVOPLAY-AIO', "EVORT-AIO", "HSW-AIO","IMG-AIO", "NSP-AIO"],
			customImg2:['PGSOFT-AIO'],
			showLobby: true,
			providerSwiper: null,
			providerCode: "",
			imgName: "",
			standaloneProv: false,
			listToDisplay:[
				{option: 30, fallb:"kissh5", img:"kissh5", code: "KISSH5"},
				// {option: 31, fallb:"mega888", img:"mega888", code: "MEGA888"},
				{option: 0, fallb:"", img:"epicwin", code: ""},
				{option: 1, fallb:"", img:"megah5", code: ""},
				{option: 2, fallb:"", img:"pragmatic", code: ""},
				{option: 3, fallb:"", img:"jili", code: ""},
				{option: 4, fallb:"", img:"live22", code: ""},
				{option: 5, fallb:"", img:"spade", code: ""},
				{option: 6, fallb:"", img:"joker", code: ""},
				{option: 7, fallb:"", img:"habanero", code: ""},
				{option: 8, fallb:"", img:"cq9", code: ""},
				{option: 9, fallb:"", img:"fachai", code: ""},
				{option: 10, fallb:"", img:"jdb", code: ""},
				{option: 11, fallb:"", img:"jdb-gtf", code: ""},
				{option: 12, fallb:"", img:"microgaming", code: ""},
				{option: 24, fallb:"", img:"hacksaw", code: ""},
				{option: 21, fallb:"", img:"nolimit", code: ""},
				{option: 22, fallb:"", img:"bng", code: ""},
				{option: 13, fallb:"", img:"bgaming", code: ""},
				{option: 14, fallb:"", img:"yesbingo", code: ""},
				{option: 15, fallb:"", img:"relax", code: ""},
				{option: 16, fallb:"", img:"evoplay", code: ""},
				{option: 17, fallb:"", img:"png", code: ""},
				{option: 18, fallb:"", img:"netent", code: ""},
				{option: 19, fallb:"", img:"redtiger", code: ""},
				{option: 20, fallb:"", img:"btg", code: ""},
				{option: 23, fallb:"", img:"advant-play", code: ""},
				{option: 25, fallb:"7mojo", img:"7mojo", code: "GPK7MJ"},
				{option: 26, fallb:"booming", img:"booming", code: "GPKBM"},
				{option: 27, fallb:"spinomenal", img:"spinomenal", code: "GPKSPINO"},
				{option: 28, fallb:"smartsoft", img:"smartsoft", code: "SSG"},
				{option: 29, fallb:"kingmidas", img:"kingmaker", code: "QM"},
			],
			visibleItems: [], // Items currently displayed
			perPage: 12, // Number of items per load
      currentPage: 1,
		}
	},
	computed: {
		isLoggedIn(){
			return this.$store.getters.isLoggedIn
		},
		accountID() {
			return this.$store.getters.accountID
		},
		sessionToken() {
			return this.$store.getters.sessionToken
		},
		getLanguage() {
      return this.$store.getters.language || "en"
    },
    matchedLocale(){
      switch(this.getLanguage){
        case "en":
          return "en"
        case "my":
          return "my"
        case "zh":
          return "zh-CN"
        default :
          return "en"
      }
    },
	},
	watch:{
    $route (to, from){
      this.currentPath = to.path
    }
	},	
	created(){
		$('link[rel="canonical"]').attr('href', `${window.location.protocol}//${window.location.hostname}/slot`);
		// this.getSeo("slot")
	},
	mounted(){
		window.scroll(0,0)
		this.visibleItems= this.listToDisplay.slice(0, this.perPage)
		// EventBus.$on("scroll", (data) => {
		// 	if(data == true){
		// 		this.$nextTick(() => {
		// 			// then wait for the browser’s layout/paint
		// 			requestAnimationFrame(() => {
		// 				setTimeout(this.scrolltoDiv, 500)
		// 			})
		// 		})
		// 	}
		// });
		
		
		this.currentPath = this.$router.currentRoute.path
		if(!_.isEmpty(this.$route.params)){
      // if(this.$route.params.custom == true){
			// 	this.providerSelected = 8
			// }
			// if(this.$route.params.target){
			// 	this.providerSelected = Number(this.$route.params.target)
			// }
    }
		if ($('.glcat-swiper').length) {
			const gboxSwiper = new Swiper('.glcat-swiper', {
				slidesPerView: 4.5,
				spaceBetween: 4,
				navigation: {
					nextEl: '.glcat-swiper-next',
					prevEl: '.glcat-swiper-prev'
				},
				// watchOverflow: true,
				autoplay:false,
				breakpoints: {
					768: {
						slidesPerView: 4.5
					},
					960: {
						slidesPerView: 6
					}
				}
			})
    }
		// this.getProviderlist()
		if ($('.glpro-swiper').length) {
        this.providerSwiper = new Swiper('.glpro-swiper', {
					slidesPerView: 3.5,
					spaceBetween: 4,
					navigation: {
							nextEl: '.glpro-swiper-next',
							prevEl: '.glpro-swiper-prev'
					},
					watchOverflow: true,
					autoplay:false,
					breakpoints: {
							768: {
									slidesPerView: 6.5
							},
							960: {
									slidesPerView: 6.5
							}
					}
			})
			
		}
	},
	methods:{
		// initSwiper(){
		// 	// if (this.gboxSwiper) this.gboxSwiper.destroy(true,true)
		// 	const gboxSwiper = new Swiper('.glpro-swiper', {
		// 		slidesPerView: 3.5,
		// 		spaceBetween: 4,
		// 		navigation: {
		// 			nextEl: '.glpro-swiper-next',
		// 			prevEl: '.glpro-swiper-prev'
		// 		},
		// 		watchOverflow: true,
		// 		autoplay:false,
		// 		breakpoints: {
		// 			768: { slidesPerView: 6.5 },
		// 			960: { slidesPerView: 6.5 }
		// 		},
		// 		// make Swiper react to DOM changes
		// 		observer: true,
		// 		observeParents: true,
		// 		observeSlideChildren: true,
		// 	})
		// },
		redirectPath(target){
      this.$router.push(target).catch(error =>{}).finally(() => {
        this.$nextTick(() => {
          EventBus.$emit('scroll', true);
        });
      });
    },
		scrolltoDiv(){
			const el = this.$refs.categories
      if (!el) return
			
      el.scrollIntoView({ behavior: 'smooth', block: 'start', inline: "nearest" })
		},
		openModal(){
			$("#logModal").modal('show')
		},
		toggleFav(){
			this.showFav = !this.showFav
		},
		toggleSearch(){
			this.showSearch = !this.showSearch
		},
		cancelSearch(){
			this.showSearch = false
			this.searchinput = ""
		},
		getSeo(page){
			let page_name = page
			this.$store
				.dispatch("user/getSeo", {page_name})
				.then(response => {
					this.loading = false;
					this.feedback.success = response.success
					if (this.feedback.success == true) {
						if(response.data.length > 0){
							// this.$store.dispatch("user/seoInfo", response.data[0])
						}
					} else {
						if((typeof response.status) != 'object'){
							this.$helpers.showDialog(vm.$tc("ui.attention"), vm.$tc("message.list." + response.status), "info", this)
						}
					}
				})
				.catch(response => {
					this.loading = false;
					var vm = this;
					if((typeof response.status) != 'object'){
						this.$helpers.showDialog(vm.$tc("ui.attention"), vm.$tc("message.list." + response.status), "info", this)
					}
				});
		},
		selectOption(option, code, img){
			this.showLobby = false
			this.changeProvider(option, code, img)
			this.providerSwiper.slideTo(option, 0);
		},	
		changeProvider(option, code, img){
      if(option !== this.providerSelected){
        this.providerSelected = option
				if(option > 24){
					if([30,31].includes(option)){
						this.standaloneProv = true
					}else{
						this.standaloneProv = false
					}
				}else{
					this.standaloneProv = false
				}
      }
      if(code){
				this.providerCode = code
			}
			if(img){
				this.imgName = img
			}
			
      this.showFav = false
      // if(option === this.providerSelected){
      // 	return
      // }else{
      // 	this.providerSelected = option
      // }
    },
		// getProviderlist(){
    //   this.pageLoading = true
		// 	var url = config.getProviderlist()
    //   this.$http.post(url, {
    //     "category": "SLOTS"
    //   }).then(
    //     successResponse => {
    //       if(successResponse){
    //         if (typeof successResponse.data.status == "string") {
    //           this.feedback.success = successResponse.status == "200";
    //         } else {
    //           this.feedback.success = successResponse.status == 200;
    //         }
    //         this.feedback.status = successResponse.status;
    //         if (this.feedback.success == true) {
		// 					if(successResponse.data.value.length > 0){
		// 						this.providerList = successResponse.data.value
		// 						this.providerSelected = this.providerList[0].provider_code
		// 						this.$nextTick(this.initSwiper)
		// 					}
    //         } else {
    //         }
		// 				this.pageLoading = false
    //       }else{
    //       }
    //     },
    //     errorResponse => {
    //       this.pageLoading = false
    //       console.log(errorResponse)
    //     }
    //   );
    // },
		getImg(code){
			return `/new/img/provider/${code}.png`
		},
		loadMore() {
      const start = this.currentPage * this.perPage;
      const newItems = this.listToDisplay.slice(start);

      this.visibleItems = [...this.visibleItems, ...newItems];
      this.currentPage++;
    },
	}
}
</script>
<style lang="scss" scoped>
.iicon{
	@media(min-width: 681px) {
		position: inherit;
		max-width: 100% !important;
	}
	
}
.gbox-search .iicon{
	@media(min-width: 681px) {
		width: 30px;
		height: inherit;
	}
	
}

</style>
